<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import _ from "lodash";
import { RouterLink, useRouter } from "vue-router";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import { useAlertStore } from "../../../../../stores/alertStore";
import adminCorporationService from "@/pages/admin/services/corporation/adminCorporationService";
const {$alert, $confirm} = useAlertStore();

const loadingStore = usePageLoadingStore();
const loaded = ref(false);
const { $desiredJob, $interests, $corpState, $ojfStateGb, $adminJoinStateGb, $bizNum, $phoneNum, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $gb } = getCurrentInstance().appContext.config.globalProperties;


const router = useRouter();

const props = defineProps({
  corporation: {
    type: Object,
    default: () => ({}),
  },
});

const corporation = computed(() => props.corporation || {});
const jobFairList = ref([]);

const ojfStateGb = ref($ojfStateGb);              // 진행 상태 - 특별채용관 참가 현황 tab
const adminJoinStateGb = ref($adminJoinStateGb);  // 참가 상태 - 특별채용관 참가 현황 tab

const openYnListRef = ref(null);            // 공개 상태 - 특별채용관 참가 현황 tab
const ojfStateGbListRef = ref(null);        // 진행 상태 - 특별채용관 참가 현황 tab
const adminJoinStateGbsListRef = ref(null); // 참가 상태 - 특별채용관 참가 현황 tab

const searchOpen = ref(true);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

const searchInput4 = ref({ // 특별채용관 참가 현황 tab 검색조건
  openYnList: ["Y", "N"], //공개 상태
  ojfStateGbList: ["00", "01", "02", "03", "04"], // (행사) 진행 상태
  joinStateGbsList: ['01', '02', '03', '04', '11', '21'], // (행사) 참가 상태
  searchOjfName: '',
});

const retrieveCorpJobFairList = () => {
  let paramObj = {
    corpId: corporation.value.corpId,
    searchOpenYn: _.map(searchInput4.value.openYnList).join(','),
    searchOjfStateGb: _.map(searchInput4.value.ojfStateGbList).join(','),
    searchJoinStateGb: _.map(searchInput4.value.joinStateGbsList).join(','),
    searchOjfName: searchInput4.value.searchOjfName,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  //loadingStore.loading = true;
  loaded.value = false;
  adminCorporationService.retrieveAllRecruitmentHallByCorpIdPaging(paramObj)
      .then( async (res) => {
        //loadingStore.loading = false;
        loaded.value = true;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobFairList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    //loadingStore.loading = false;
    loaded.value = true;
  });
}

const GroupOpenYn = ref([
  { label: "공개", value: "Y" },
  { label: "비공개", value: "N" }
]);

const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
])


// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveCorpJobFairList();
}

// 검색조건 - 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;

  retrieveCorpJobFairList();
}


// 검색조건 - '초기화' 버튼
const clearSearchInput = () => {
  searchInput4.value = {
    openYnList: ["Y", "N"],
    ojfStateGbList: ["00", "01", "02", "03", "04"],
    joinStateGbsList: ['01', '02', '03', '04', '11', '21'],
    searchOjfName: ""
  };
  openYnListRef.value.initOptions();
  ojfStateGbListRef.value.initOptions();
  adminJoinStateGbsListRef.value.initOptions();
}

const onClickSearch = () => {
  currentPage.value = 1;
  retrieveCorpJobFairList();
}

const goJobFairDetail = (ojfId, corpId) => {
  router.push({ name: 'CorporationJobFairDetail', query : { ojfId: ojfId, corpId: corpId }});
}

onMounted(()=>{
  retrieveCorpJobFairList();
})
</script>
<template>
  <!-- s: 검색 -->
  <div class="filter-wrap" :class="{'open': searchOpen}">
    <p @click="searchOpen = !searchOpen">검색</p>
    <div class="filter">
      <dl>
        <dt style="display:block;"><span>공개 상태</span><br /><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="openYnListRef"
              className="mr-md"
              name="openYnList"
              v-model="searchInput4.openYnList"
              :options="GroupOpenYn" />
        </dd>
      </dl>
      <dl>
        <dt style="display:block;"><span>진행 상태</span><br /><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="ojfStateGbListRef"
              className="mr-md"
              name="ojfStateGbList"
              v-model="searchInput4.ojfStateGbList"
              :options="ojfStateGb" />
        </dd>
      </dl>
      <dl>
        <dt style="display:block;"><span>참가 상태</span><br /><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="adminJoinStateGbsListRef"
              className="mr-md"
              name="ojfStateGbList"
              v-model="searchInput4.joinStateGbsList"
              :options="adminJoinStateGb" />
        </dd>
      </dl>
      <!-- 행사명 검색 -->
      <dl>
        <dt>행사명</dt>
        <dd>
          <KSAInput class="text-box" v-model="searchInput4.searchOjfName" placeholder="행사명을 입력해 주세요." />
        </dd>
      </dl>
      <div class="btn-wrap">
        <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
        <KSAPrimaryButton text="검색" @click="onClickSearch" />
      </div>
    </div>
  </div>
  <!-- e: 검색 -->
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
    <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
  </div>
  <div class="table-form">
    <table class="horizontal" v-if="jobFairList !== null">
      <tr>
        <th>NO</th>
        <th>행사ID</th>
        <th>행사구분</th>
        <th>공개 상태</th>
        <th>진행 상태</th>
        <th>행사명</th>
        <th>접수기간</th>
        <th>행사기간</th>
        <th>참가 상태</th>
        <th>신청일</th>
        <th>신청 마스터</th>
      </tr>
      <tr v-for="ojf in jobFairList">
        <td>{{ ojf.boardNo }}</td>
        <td>{{ ojf.ojfId }}</td>
        <td>
          <span v-if="ojf.ojfGb === '01'">기업공채관</span>
          <span v-else>채용박람회</span>
        </td>
        <td>
          <span v-if="ojf.openYn === 'Y'">공개</span>
          <span v-else>비공개</span>
        </td>
        <td>
          <!-- 상태가 '03'일 때 -->
          <span v-if="ojf.ojfStateGb === '03'" class="blue">
              {{ $gbNameKR("OJF_STATE_GB", ojf.ojfStateGb) }}
              {{ $isInRegPeriod(ojf.regStartYmd, ojf.regEndYmd) ? '(신청 접수중)' : ($isAfterRegEnd(ojf.regEndYmd) ? '(신청 마감)' : '') }}
          </span>
          <!-- 상태가 '03'이 아닐 때 -->
          <span v-else :class="ojf.ojfStateGb === '05' ? 'red' : ojf.ojfStateGb === '04' ? 'gray' : ''">
              {{ $gbNameKR("OJF_STATE_GB", ojf.ojfStateGb) }}
          </span>
        </td>
        <td class="clickable blue" @click="goJobFairDetail(ojf.ojfId, corporation.corpId)">{{ ojf.ojfName }}</td>
        <td>{{ $yyyymmdd(ojf.regStartYmd) }} ~ {{ $yyyymmdd(ojf.regEndYmd) }}</td>
        <td>{{ $yyyymmdd(ojf.ojfStartYmd) }} ~ {{ $yyyymmdd(ojf.ojfEndYmd) }}</td>
        <td :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">
          {{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}
        </td>
        <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
        <td class="clickable blue">
          <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="jobFairList.length === 0">
      참가 중인 행사가 없습니다.
    </div>
    <Paginate
        v-if="jobFairList.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
</template>
<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>